import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import OneJob from "./OneJob";
import Filter from "./Filter";
import { getInlineLoader } from "../Helpers";
import { Link } from "react-router-dom";

export default function JobsContent() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [filter, setFilter] = useState("");

  async function init() {
    setReady(false);
    await Promise.all([appContext.getAllJobPosts()]);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    const jobs = appContext.allJobPosts || [];
    const filteredJobs = jobs.filter((item) =>
      item.title.toLowerCase().includes(filter.toLowerCase()),
    );

    return (
      <div
        className="MainBodySection bg-background"
        style={{ paddingTop: "50px", paddingBottom: "50px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h4 className="main-section-title">
                Current Job Openings
                <span
                  style={{
                    display: "block",
                    borderBottom: "3px solid var(--secondaryColor)",
                    width: "50px",
                    margin: "10px auto 0",
                  }}
                ></span>
              </h4>
            </div>

            <Filter filter={filter} setFilter={setFilter} />

            {filter && filter.trim().length > 0 && (
              <div className="col-md-12 text-center mb-4">
                <h6 className="font-light" style={{ fontSize: "18px" }}>
                  Search Results For:{" "}
                  <span className="font-semi-bold">{filter}</span>
                </h6>
              </div>
            )}

            {filteredJobs.length > 0 ? (
              filteredJobs.map((item) => (
                <div
                  className="col-lg-6 col-xl-4 mb-4"
                  key={item.uuid}
                  data-aos="fade-up"
                >
                  <OneJob data={item} />
                </div>
              ))
            ) : (
              <div className="col-md-12 mb-1 mt-1">
                <h6>
                  {filter
                    ? "No matching jobs found"
                    : "No job openings available"}
                </h6>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }
}
